// extracted by mini-css-extract-plugin
export var currencyInput = "_kk-1";
export var currencySymbol = "_kk-0";